import React from 'react';
import * as yup from 'yup';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { api } from '@api';
import { HookFormTextArea } from '@components/ReactHookFormFields/HookFormTextArea';
import { useIncidentCreation } from '@hooks/incidents';
import { useCustomTranslations } from '@hooks/useCustomTranslations';
import { IncidentClassification, IncidentSubClassification } from '@models';

import { IncidentFormWrapper } from '../IncidentFormWrapper';

export const KeysLostForm = ({ customTranslations }: ParsedEntry<IWidget>) => {
  const { t } = useCustomTranslations(customTranslations);

  const { create } = useIncidentCreation({
    postIncident: api.incidents.postLostKeyRequest,
    classifications: {
      classification: IncidentClassification.KEYS,
      subClassification: IncidentSubClassification.LOST_KEY,
    },
  });

  return (
    <IncidentFormWrapper
      incidentKind="KeysLost"
      defaultValues={{ description: '' }}
      validationSchema={yup.object().shape({
        description: yup.string().required(),
      })}
      onSubmit={(values) => create({ ...values, title: t('messageTitle') })}
    >
      <HookFormTextArea
        name="description"
        type="text"
        label={{
          type: 'static',
          value: t('inputLabel'),
        }}
        rows={6}
        maxLength={1800}
      />
    </IncidentFormWrapper>
  );
};
